export default __webpack_public_path__ + "static/media/new_spinning.5d3a7182.mp3";